import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';


export default class EditTimeSheetConfirmDeleteModal extends Component {
  
    render() {
        let messageBody = "";
        let messageTitle = "";
        if (this.props.messageTitle && this.props.messageBody) {
            messageBody = this.props.messageBody;
            messageTitle = this.props.messageTitle;
        }
        return (
           
                <Modal isOpen={this.props.modal} toggle={this.props.toggleModal} size='sm'>
                    <ModalHeader toggle={this.props.toggleModal}>
                        {messageTitle}
                    </ModalHeader>
                    <ModalBody className="bg-white">
                        <div dangerouslySetInnerHTML={{__html: messageBody}}/>
                    </ModalBody>
                    <ModalFooter>
                        <Button className='add-button btn-danger' 
                            onClick={this.props.deleteTimesheet}
                        >Delete</Button>
                        <Button className='ml-2' 
                            color="secondary" onClick={this.props.toggleModal}
                        >Cancel</Button>
                    </ModalFooter>
                </Modal>
           
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/daliyAttendance/editTimeSheetConfirmDeleteModal.js